export function makeStarterTemplate({ contentId, type = "lesson", language = "fa" }) {
    return {
        id: contentId,
        schemaVersion: 1,
        contentVersion: 1,
        meta: {
            type,
            title: "هنوان",
            difficulty: "مبتدی",
            estimatedTime: 0,
            xp: 0,
            language
        },
        fragments: [
            {
                id: "frag_1",
                blocks: [
                    {
                        id: "txt_1",
                        type: "text",
                        config: { text: "اینجا شروع کن..." }
                    }
                ]
            }
        ]
    };
}
